import { useState } from 'react';
import ScheduleDemoModal from './ScheduleDemoModal';

export default function useScheduleDemoModal() {
  const [isScheduleDemoModalVisible, setIsScheduleDemoModalVisible] = useState(false);

  const toggleScheduleDemoModal = () => {
    setIsScheduleDemoModalVisible(!isScheduleDemoModalVisible);
  };

  return {
    ScheduleDemoModal,
    isScheduleDemoModalVisible,
    toggleScheduleDemoModal,
  };
}
